import gql from "graphql-tag";

export const GET_TEMPLATE_FEATURES = gql`
  query GetTemplateFeatures($options: GetManyOptions, $presentationId: ID!) {
    getTemplateFeatures(options: $options, presentationId: $presentationId) {
      globalAssets {
        id
        name
        code
        isCommon
        basePrice
        currency
        isVisible
        featurePosition
      }
      sectionAssets {
        id
        name
        code
        isCommon
        basePrice
        currency
        isVisible
        featurePosition
        section {
          id
          name
        }
        costumeAttributes {
          id
          name
          images
          costumeValues {
            id
            name
            currency
            desc
            deadline
            inventory
            isMandatory
            isLabel
            isVisible
            disclaimer
            topupPrice
            minDownPayment
            position
          }
          desc
          dynaInventory
          isDynamic
          isLabel
          isMandatory
          isSingleVal
          isVisible
        }
      }
    }
  }
`;
